// Custom schemas — user-managed. Add project-specific Zod schemas here; never overwritten by template sync.
import { z } from "zod";

/** Body for POST /api/disposable/aliases (optional fields). */
export const DisposableAliasBodySchema = z.object({
	ttl: z.string().optional(),
	local_part: z.string().optional(),
	mail_domain: z.string().optional(),
});

export type DisposableAliasBodyInput = z.infer<
	typeof DisposableAliasBodySchema
>;

export const DisposableReportBodySchema = z.object({
	local_part: z.string().min(1),
	reason: z.string().min(1),
	contact_email: z.string().email().optional().or(z.literal("")),
});

export type DisposableReportBodyInput = z.infer<
	typeof DisposableReportBodySchema
>;
